import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import FaceRetouchingNaturalIcon from '@mui/icons-material/FaceRetouchingNatural';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';
import PendingActionsRoundedIcon from '@mui/icons-material/PendingActionsRounded';
import { Badge, Box, IconButton, Stack, Tab, Tabs, Typography } from '@mui/material';
import React from 'react';

export type CopilotDrawerTabValue = 'chat' | 'sessions' | 'tasks';

interface Props {
  activeTab: CopilotDrawerTabValue;
  onTabChange: (value: CopilotDrawerTabValue) => void;
  onClose: () => void;
  tabsDisabled?: boolean;
  sessionActivityCount?: number;
}

export const CopilotDrawerHeader: React.FC<React.PropsWithChildren<Props>> = ({
  activeTab,
  onTabChange,
  onClose,
  tabsDisabled = false,
  sessionActivityCount = 0,
}) => {
  return (
    <Box sx={{ px: 2, py: 2 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
        <Stack direction="row" alignItems="flex-start" spacing={1.25}>
          <FaceRetouchingNaturalIcon color="action" sx={{ mt: 0.25 }} />
          <Box>
            <Typography variant="h6" sx={{ lineHeight: 1.25 }}>
              Research Companion
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Ask questions, reopen saved sessions, and track jobs.
            </Typography>
          </Box>
        </Stack>
        <IconButton onClick={onClose}>
          <CloseRoundedIcon />
        </IconButton>
      </Stack>

      <Tabs
        value={activeTab}
        onChange={(_, value: CopilotDrawerTabValue) => onTabChange(value)}
        variant="fullWidth"
        aria-disabled={tabsDisabled}
        sx={{ mt: 1.5 }}
      >
        <Tab
          icon={<ChatBubbleOutlineRoundedIcon fontSize="small" />}
          iconPosition="start"
          label="Chat"
          value="chat"
          disabled={tabsDisabled}
        />
        <Tab
          icon={
            <Badge color="primary" badgeContent={sessionActivityCount} overlap="circular">
              <HistoryRoundedIcon fontSize="small" />
            </Badge>
          }
          iconPosition="start"
          label="Sessions"
          value="sessions"
          disabled={tabsDisabled}
        />
        <Tab
          icon={<PendingActionsRoundedIcon fontSize="small" />}
          iconPosition="start"
          label="Jobs"
          value="tasks"
          disabled={tabsDisabled}
        />
      </Tabs>
    </Box>
  );
};
